var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 63,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.67,
    cy: 10.27,
    fill: "#204ecf",
    fillRule: "nonzero",
    opacity: 0.05,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#204ecf",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.67,
    cy: 10.27,
    rx: 10.01,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.81,
    cy: 52.42,
    rx: 8.76,
    ry: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.81,
    cy: 49.88,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43 7.65l-5.01 5.24-2.51-2.62M5.33 57.07c.27-1.7 1.74-2.96 3.47-2.96.87 0 1.67.31 2.29.84s1.06 1.27 1.19 2.12"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.67,
    cy: 2.88,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.19 10.07c.27-1.7 1.74-2.96 3.47-2.96.87 0 1.67.31 2.29.84s1.06 1.27 1.19 2.12"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.68,
    cy: 52.42,
    rx: 8.76,
    ry: 8.75
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.53,
    cy: 2.88,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.06 10.07c.27-1.7 1.74-2.96 3.47-2.96.87 0 1.67.31 2.29.84s1.06 1.27 1.19 2.12"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.55,
    cy: 52.42,
    rx: 8.76,
    ry: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.67 23.83v15.4M26.22 22.9v9.07H8.81v7.26M35.18 22.9v9.07h17.41v7.26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware1);
export default __webpack_public_path__ + "static/media/Software1.6f386d534f9a806e0766712a659ac03f.svg";
export { ForwardRef as ReactComponent };